import React, { useEffect, useState } from 'react'
import { DKLabel, showToast, TOAST_TYPE, DKButton, DKIcons, DKIcon, DKInput, INPUT_VIEW_DIRECTION, showLoader, removeLoader, DKCheckMark, Toggle } from "deskera-ui-library";
import { INPUT_TYPE } from '../../constants/Constant';
import { useDispatch, useSelector } from 'react-redux';
import { selectUsers, fetchUsers } from "../../../src/Redux/Slices/PayrollSlice";
import Utility from '../../utility/Utility';
import { isEmpty } from 'rxjs';
import Table from "../../services/table";
import ic_info_warning from "../../assets/icons/ic_info_gray.svg";
import ReactTooltip from "react-tooltip";



const AddEditBenefitsPopup = (props) => {


    const amountType = ['Fixed Amount', 'Percentage'
        // ,
        // {
        //   id: 'hourly',
        //   name: 'Per Hour'
        // }
    ];

    const users = useSelector(selectUsers);
    const dispatch = useDispatch();

    // let selectedUsers = []

    const [benefitState, setBenefitState] = useState({
        annualMaxContribution: 0,
        benefitId: "",
        compliance: { countryCode: "US", deductionType: "pretaxdeduction" },
        countryCode: "US",
        employeeDeductionAmount: 0,
        employeeDeductionType: "amount",
        employerDeductionAmount: 0,
        employerDeductionType: "amount",
        isActive: true,
        isForAllEmployees: true,
        name: "",
        type: "pretaxdeduction",
        users: [],
    });
    const [userOptions, setUserOption] = useState([])
    const [selectedUsers, setSelectedUsers] = useState([])
    const [invalidFields, setInvalidFields] = useState({
        benefitName: false,
        users: false,
        employerContribution: false,
        employeeContribution: false
    })


    useEffect(() => {
        if (Utility.isEmpty(users)) {
            loadUsersList({})
        }

    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(users)) {
            let options = []
            users.users.forEach(element => {
                options.push(`${element.firstName} ${element.lastName}`)
            });
            setUserOption(options)
            if (Object.entries(props.data).length > 0) {
                setBenefitState({ ...props.data })
                setUserInEdit()
            }
        }

    }, [users])

    const setUserInEdit = () => {
        let selectedusersIndex = []
        props.data.users.forEach(u => {
            users.users.forEach((d, index) => {
                if (d.userId === u.userId) {
                    selectedusersIndex.push(index)
                }
            })
        })
        setSelectedUsers(selectedusersIndex)
    }

    const saveBenfits = () => {
        let isInvalidField = false
        if (Utility.isEmpty(benefitState.name) && (!benefitState.isForAllEmployees && selectedUsers.length === 0)) {

            setInvalidFields({ ...invalidFields, benefitName: true, users: true })
            return
        }
        if (!benefitState.isForAllEmployees && selectedUsers.length === 0) {
            isInvalidField = true
            setInvalidFields({ ...invalidFields, users: true })
        }

        if (Utility.isEmpty(benefitState.name)) {
            isInvalidField = true
            setInvalidFields({ ...invalidFields, benefitName: true })
        }
        if (isInvalidField || invalidFields.employerContribution || invalidFields.employeeContribution) {
            return
        }

        if (!benefitState.isForAllEmployees) {
            benefitState.users = getUsersByIndex()
        }

        benefitState.employeeDeductionAmount = Utility.isEmpty(benefitState.employeeDeductionAmount) ? 0 : parseInt(benefitState.employeeDeductionAmount)
        benefitState.employerDeductionAmount = Utility.isEmpty(benefitState.employerDeductionAmount) ? 0 : parseInt(benefitState.employerDeductionAmount)
        benefitState.annualMaxContribution = Utility.isEmpty(benefitState.annualMaxContribution) ? 0 : parseInt(benefitState.annualMaxContribution)

        save({})


        console.log()

    }

    const save = async () => {

        try {

            showLoader(`Processing, please wait...`);
            if (Object.entries(props.data).length === 0) {
                Table.saveBenefit(benefitState).then((data) => {
                    removeLoader();
                    showToast("Benefit saved Successfully", TOAST_TYPE.SUCCESS);
                    props.onClose();
                    props.loadBenefit({})
                })
            } else {
                Table.updateBenefit(benefitState).then((data) => {
                    removeLoader();
                    showToast("Benefit updated Successfully", TOAST_TYPE.SUCCESS);
                    props.onClose();
                    props.loadBenefit({});
                })
            }
        } catch (err) {
            removeLoader();
            showToast('Error updating payrolls: ', TOAST_TYPE.FAILURE);
        }
    }


    const getUsersByIndex = () => {
        let u = []
        selectedUsers.forEach(index => {
            u.push({ "userId": users.users[index].userId, "iamUserId": parseInt(users.users[index].iamUserId) })
        })
        return u
    }


    const loadUsersList = async (config) => {
        try {
            // PayrollService.apiConfig = config;
            await dispatch(fetchUsers());
        } catch (err) {
            console.error('Error loading workweeks: ', err);
        }
    }

    const getEmployerContributionField = () => {
        return (
            <div className="mt-xl d-flex" style={{ marginTop: "0px" }}>
                
                <div className="column ml">
                    <div className="d-flex">
                    <DKInput
                        value={benefitState.employerDeductionAmount}
                        title={"Employer Contribution / Pay Period"}
                        type="number"
                        // canValidate={invalidFields.employerContribution}
                        hasError={invalidFields.employerContribution}
                        errorMsg={"Please enter valid percentage."}
                        canValidate={invalidFields.employerContribution}
                        required = {false}
                        onChange={(val) => {
                            benefitState.employerDeductionAmount = val
                            if (benefitState.employerDeductionType === "percent") {
                                if (!Utility.isEmpty(val) && parseInt(val) > 100) {
                                    setInvalidFields({ ...invalidFields, employerContribution: true })
                                } else {
                                    setInvalidFields({ ...invalidFields, employerContribution: false })
                                }
                            } else {
                                setInvalidFields({ ...invalidFields, employerContribution: false })
                            }
                        }}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}

                    />
                    <span style={{
                            marginTop: 28,
                            marginLeft: -21,
                            zIndex: 1
                          }}
                          data-tip="This amount is deducted from employee each pay period to pay for this benefit.This can be changed for each employee later."
                    >
                        <DKIcon className="mr-s ic-s"  src={ic_info_warning} />
                    </span>
                    </div>
                    {invalidFields.employerContribution && (
                        <DKLabel
                            className="pl-s fs-s pt-s unselectable text-red"
                            style={{
                                whiteSpace: "nowrap",
                            }}
                            text={
                                "Please enter valid percentage."
                            }
                        />
                    )}
                </div>
                <div className="column ml-l" style={{ width: "200px" }}>
                    <DKInput
                        title={" "}
                        value={[benefitState.employerDeductionType === "amount" ? 0 : 1]}
                        // className="mb-l"
                        type={INPUT_TYPE.SELECT}
                        showError={false}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        required={false}
                        canValidate={false}
                        options={amountType}
                        onChange={(value) => {
                            if (value[0] === 1) {
                                if (!Utility.isEmpty(benefitState.employerDeductionAmount) && parseInt(benefitState.employerDeductionAmount) > 100) {
                                    setInvalidFields({ ...invalidFields, employerContribution: true })
                                } else {
                                    setInvalidFields({ ...invalidFields, employerContribution: false })
                                }
                            } else {
                                setInvalidFields({ ...invalidFields, employerContribution: false })
                            }
                            setBenefitState({ ...benefitState, employerDeductionType: value[0] === 0 ? "amount" : "percent" })
                        }}
                    />
                </div>

            </div>
        )
    }

    const getEmployeeContributionField = (label, value) => {
        return (

            <div className="mt-xl d-flex" style={{ marginTop: "0px" }}>
                <div className="column ml">
                    <div className="d-flex">
                        <DKInput
                            value={benefitState.employeeDeductionAmount}
                            title={"Employee Contribution / Pay Period"}
                            type="number"
                            canValidate={invalidFields.employeeContribution}
                            required={false}
                            onChange={(val) => {
                                benefitState.employeeDeductionAmount = val
                                if (benefitState.employeeDeductionType === "percent") {
                                    if (!Utility.isEmpty(val) && parseInt(val) > 100) {
                                        setInvalidFields({ ...invalidFields, employeeContribution: true })
                                    } else {
                                        setInvalidFields({ ...invalidFields, employeeContribution: false })
                                    }
                                } else {
                                    setInvalidFields({ ...invalidFields, employeeContribution: false })
                                }
                            }}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}

                        />
                        <span style={{
                            marginTop: 28,
                            marginLeft: -21,
                            zIndex: 1
                        }}
                            data-tip="This amount is paid by company each pay period beyond what was deducted from employee's pay."
                        >
                            <DKIcon className="mr-s ic-s" src={ic_info_warning} />
                        </span>
                    </div>
                    
                    {invalidFields.employeeContribution && (
                        <DKLabel
                            className="pl-s pt-s fs-s unselectable text-red"
                            style={{
                                whiteSpace: "nowrap",
                            }}
                            text={
                                "Please enter valid percentage."
                            }
                        />
                    )}
                </div>
                <div className="column ml-l" style={{ width: "200px" }}>
                    <DKInput
                        title={" "}
                        value={[benefitState.employeeDeductionType === "amount" ? 0 : 1]}
                        type={INPUT_TYPE.SELECT}
                        showError={false}
                        required={false}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        canValidate={false}
                        options={amountType}
                        onChange={(value) => {
                            if (value[0] === 1) {
                                if (!Utility.isEmpty(benefitState.employeeDeductionAmount) && parseInt(benefitState.employeeDeductionAmount) > 100) {
                                    setInvalidFields({ ...invalidFields, employeeContribution: true })
                                } else {
                                    setInvalidFields({ ...invalidFields, employeeContribution: false })
                                }
                            } else {
                                setInvalidFields({ ...invalidFields, employeeContribution: false })
                            }
                            setBenefitState({ ...benefitState, employeeDeductionType: value[0] === 0 ? "amount" : "percent" })

                        }}
                    />
                </div>

            </div>

        )
    }

    const onAllUsersToogle = () => {
        setBenefitState({ ...benefitState, isForAllEmployees: !benefitState.isForAllEmployees })
    }

    return (
        <div className="popup-window pl-xl pr-xl" style={{ maxWidth: "500px" }}>
            <div className="parent-width custom-scroll scrollbar-thin" style={{ overflowY: "auto", overflowX: "hidden" }}>
            <ReactTooltip
                      type="dark"
                      place="right"
                      html={true}
                      effect="solid"
                    />
                <div className="row">
                    <DKLabel text={`${props.data?.benefitId ? "Edit":"Add"} Benefit`} className="fs-r text-align-left fw-m fs-l width-80" />
                    <div className="row-reverse">
                        <DKButton
                            title="Save"
                            className="border-m ml-r bg-app text-white"
                            onClick={() => saveBenfits()}
                        />
                        <DKButton
                            title="Cancel"
                            className="g-gray1 border-m"
                            onClick={(event) => {
                                props.onClose();
                            }}
                        />

                    </div>
                </div>
                <div className="row">
                    <DKInput
                        value={benefitState.name}
                        title="Benefit name"
                        type="text"
                        canValidate={invalidFields.benefitName}
                        required={true}
                        onChange={(value) => {
                            benefitState.name = String(value).trim();
                            if (Utility.isEmpty(benefitState.name)) {
                                setInvalidFields({ ...invalidFields, benefitName: true })
                            }
                        }}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}

                    />
                </div>
                <div className="mt-l parent-width">
                    <DKLabel
                        text="Type of Deduction"
                        className="text-align-left fw-m"

                    />
                    <div className="row" >
                        <div classname="display-block column" style={{ width: "40%" }}>
                            <label
                                className="p-s row align-items-center width-auto cursor-hand"
                            >
                                <input
                                    type="radio"
                                    className="mb-xs"
                                    checked={benefitState.compliance.deductionType == "pretaxdeduction"}
                                    onChange={(e) => {
                                        // let compliance = benefitState.compliance
                                        // compliance.deductionType = "pretaxdeduction"
                                        // setBenefitState({ ...benefitState, compliance: compliance })
                                        setBenefitState({ ...benefitState, compliance: {...benefitState.compliance, deductionType: "pretaxdeduction"} })

                                    }}
                                />
                                <DKLabel
                                    className="fs-m pl-xs pr-l"
                                    text="Pre-Tax"
                                />
                            </label>
                        </div>
                        <div classname="display-block column" style={{ width: "40%" }}>
                            <label
                                className="p-s row align-items-center width-auto cursor-hand"
                            >
                                <input
                                    type="radio"
                                    className="mb-xs"
                                    checked={benefitState.compliance.deductionType == "posttaxdeduction"}
                                    style={{ minHeight: '34px', borderStyle: 'solid' }}
                                    onChange={(e) => {
                                        // let compliance = benefitState.compliance
                                        // compliance.deductionType = "posttaxdeduction"
                                        setBenefitState({ ...benefitState, compliance: {...benefitState.compliance, deductionType: "posttaxdeduction"} })
                                    }}
                                />
                                <DKLabel
                                    className="fs-m pl-xs pr-l"
                                    text="Post-Tax"
                                />
                            </label>
                        </div>

                    </div>
                </div>
                <div className="row mt-s">
                    {getEmployerContributionField()}
                </div>
                <div className="row mt-s">
                    {getEmployeeContributionField()}
                </div>
                <div className="row mt-s">
                    <DKInput
                        value={benefitState.annualMaxContribution}
                        title={"Annual Maximum Contribution"}
                        type="number"
                        canValidate={false}
                        required={false}
                        onChange={(value) => { benefitState.annualMaxContribution = value }}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}

                    />
                </div>

                <div className="mt-l">
                    <DKLabel
                        className="fs-r pl-xs pr-l mb-s fw-m"
                        text="Applicable to"
                    />
                    <div
                        className="row"
                    // style={{ alignItems: "flex-end", justifyContent: "flex-end" }}
                    >
                        <Toggle
                            className="border-n"
                            isOn={benefitState.isForAllEmployees}
                            onChange={() => onAllUsersToogle()}
                        />
                        <DKLabel
                            className="m-v-s ml-l mr-l"
                            text={"All Users"}
                        />
                    </div>
                </div>
                {!benefitState.isForAllEmployees && <div className="parent-width mt-l">
                    <DKInput
                        value={selectedUsers}
                        title={"Users"}
                        // className="mb-l"
                        type={INPUT_TYPE.MULTI_SELECT}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        required={true}
                        canValidate={true}
                        options={userOptions}
                        onChange={(value) => {
                            setSelectedUsers(value)

                        }}
                    />
                </div>}

                <div className="row mt-l">
                    {/* <div classname="display-block column" style={{ width: "40%" }}>
                    <label
                        className="p-s row align-items-center width-auto cursor-hand"
                    >
                        <div onClick={() => {
                            setBenefitState({ ...benefitState, isActive: !benefitState.isActive })
                        }} >
                            <input
                                type="radio"
                                className="mb-xs"
                                checked={benefitState.isActive}

                            />
                        </div>
                        <DKLabel
                            className="fs-m pl-xs pr-l"
                            text={benefitState.isActive ? "Active" : "Inactive"}
                        />
                    </label>
                </div> */}
                    <div
                        className="row pt-s align-items-center parent-height cursor-hand mb-l"
                        onClick={() => {
                            setBenefitState({ ...benefitState, isActive: !benefitState.isActive })
                        }}

                    >
                        <DKCheckMark isSelected={benefitState.isActive} color="bg-app" /><DKLabel className="ml-s" text={benefitState.isActive ? "Active" : "Inactive"} />
                    </div>

                </div>
            </div>
        </div >

    )
}

export default AddEditBenefitsPopup
